module.exports = __webpack_public_path__ + "img/compresor-5.49e131c8.png";